import axios from 'axios';

export default {
  create(config = {}) {
    const httpClient = axios.create(config);

    return httpClient;
  },
};
